import React, { useEffect, useState } from 'react';
import {
  Button as AntdButton,
  message,
  Spin,
  Checkbox,
  Statistic,
  Progress,
} from 'antd';
import { message as notificationMessage } from 'helpers/notificationhelper';
import OtpInput from 'react-otp-input';
import moment from 'moment';

import {
  updateFormSubmissions,
  getMostRecentAnswerPrefill,
} from 'api/formSubmissions';

import 'styles/Attachments.scss';

import { Container, Row, Col } from 'react-bootstrap';

import Editor from 'pages/FormBuilder';

import { createOTP, validateOTP } from 'api/otp';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { setWillTaskListFetch } from 'redux/actions/appointment';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { LoadingOutlined } from '@ant-design/icons';

import {FileTextOutlined} from '@ant-design/icons';

const { Countdown } = Statistic;
const RESEND_OTP_COOLDOWN = 300000;

const FormSubmitModal = ({
  visible,
  setVisible,
  fullScreen,
  activeSubmissionId,
  designId,
  name,
  onSuccess,
  formStatus,
  formDraw,
  setFormDraw,
  notificationModal,
  span
}) => {
  const nonValuedControls = [
    'Container',
    'Card',
    'Panel',
    'Column',
    'Button',
    'Text',
    'Grid',
  ];
  const [excludeValidation, setExcludeValidation] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [otpValue, setOtpValue] = useState('');
  const [isOTPFormShown, setOTPFormShown] = useState(false);
  const [isPageLoading, setPageLoading] = useState(false);
  const [resendOtpOnCooldown, setResendOtpOnCooldown] = useState(false);
  const [formDataValues, setFormDataValues] = useState(null);
  const [formDataErrors, setFormDataErrors] = useState([]);
  const [formDesignData, setFormDesignData] = useState(null);
  const [isFormSubmissionLoading, setFormSubmissionLoading] = useState(false);
  const [formBuilderUtilities, setFormBuilderUtilities] = useState(null);
  const [isFieldsDisabled, setFieldsDisabled] = useState(false);
  const formBuilderState = useSelector((state) => state.formBuilder);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleModalCancel = () => {
    setVisible(false);
  };

  const validateAndGetFormValues = () => {
    let data = [];
    let errors = [];
    const gridValueObject = {};

    //if (formBuilderUtilities) {
    //const {
    //  actions: { setProp },
    //  query,
    //  nodes,
    //} = formBuilderUtilities;
    const {
      actions: { setProp },
      query,
      nodes,
    } = formBuilderState.utilities;

    const findGridName = (obj) => {
      const nodeControl = query.getSerializedNodes()[obj.parent];
      if (nodeControl.displayName === 'Grid') {
        const gridObj = query.getSerializedNodes()[obj.parent];
        return gridObj.props ? gridObj.props.name : '';
      } else if (nodeControl.displayName === 'Column') {
        const parentNode = query.getSerializedNodes()[nodeControl.parent];
        if (parentNode.displayName === 'Container') {
          const parentNode2 = query.getSerializedNodes()[parentNode.parent];
          if (parentNode2.displayName === 'Grid') {
            const gridObj = query.getSerializedNodes()[parentNode.parent];
            return gridObj.props ? gridObj.props.name : '';
          }
        }
      }
      return '';
    };

    function isNodeOrParentNodeHidden(node) {
      if (node.hidden) return true;
      else if (!node.parent) return false;
      else
        return isNodeOrParentNodeHidden(
          query.getSerializedNodes()[node.parent]
        );
    }

    Object.keys(nodes).map((serializeNodeKey) => {
      const nodeControl = query.getSerializedNodes()[serializeNodeKey];

      if (nodeControl.displayName === 'Grid') {
        const gridName = nodeControl.props.name;
        if (gridName) {
          gridValueObject[gridName] = {};
          gridValueObject[gridName].gridId = nodeControl.props.name;
          gridValueObject[gridName].gridTitle = nodeControl.props.cardTitle;
          gridValueObject[gridName].gridSerializedId = serializeNodeKey;
          if (!gridValueObject[gridName].values) {
            gridValueObject[gridName].values = [];
          }
        }
      }

      if (!nonValuedControls.includes(nodeControl.displayName)) {
        if (nodeControl.props.type === 'datetime' && !nodeControl.props.value) {
        //   nodeControl.props.value = moment();
        }

        if (
          nodeControl.props.isRequired &&
          !nodeControl.props.value &&
          !isNodeOrParentNodeHidden(nodeControl)
        ) {
          errors.push(serializeNodeKey);

          setProp(serializeNodeKey, (props) => {
            if (props.error) {
              if (
                nodeControl.props.name === 'input' &&
                nodeControl.props.type === 'datetime'
              )
                // props.value = moment();
              if (nodeControl.props.name === 'select')
                props.value =
                  props.options &&
                  props.options.length > 0 &&
                  props.options[0].value;
              if (
                nodeControl.props.name === 'input' &&
                nodeControl.props.type === 'text'
              )
                props.value = '';

              props.error.required.isVisible = true;
            }
          });
        } else {
          setProp(serializeNodeKey, (props) => {
            if (props.error) props.error.required.isVisible = false;
          });

          delete errors[serializeNodeKey];

          let nodeValue = '';

          if (
            nodeControl.props.value &&
            !isNodeOrParentNodeHidden(nodeControl)
          ) {
            if (nodeControl.props.type === 'datetime') {
              const newDate = new Date(nodeControl.props.value).toISOString();
              nodeValue = newDate;
            } else {
              nodeValue = nodeControl.props.value;
            }
          }

          if (nodeControl.props.isGridComponent === 2) {
            const gridName = findGridName(nodeControl);
            if (gridName) {
              if (!gridValueObject[gridName]) {
                gridValueObject[gridName] = {};
              }
              if (!gridValueObject[gridName].values) {
                gridValueObject[gridName].values = [];
              }

              gridValueObject[gridName].values.push({
                id: serializeNodeKey,
                name: nodeControl.props.name,
                rowId: nodeControl.props.rowId,
                label:
                  nodeControl.props.labelText &&
                  nodeControl.props.labelText.replace(':', ''),
                value: nodeValue,
                subTitle: nodeControl.props.subTitle
              });
            }
          } else {
            if (
              !nodeControl.props.isGridComponent ||
              nodeControl.props.isGridComponent !== 1
            ) {
              data.push({
                id: serializeNodeKey,
                name: nodeControl.props.name,
                label:
                  nodeControl.props.labelText &&
                  nodeControl.props.labelText.replace(':', ''),
                value: nodeValue,
                subTitle: nodeControl.props.subTitle
              });
            }
          }
        }
      }
    });
    //}
    Object.values(gridValueObject).forEach((grid) => {
      data.push({
        id: grid.gridSerializedId,
        gridId: grid.gridId,
        name: 'Grid',
        label: grid.gridTitle,
        value: grid.values,
      });
    });
    return {
      data,
      errors,
    };
  };

  const validateOTPCode = async () => {
    try {
      const response = await validateOTP({
        code: otpValue,
        uniqueId: `fs-${activeSubmissionId}`,
      });

      if(response.data) {
        saveFormAsComplete(formDataValues, formDataErrors);
      } else {
        notificationMessage.error('Invalid OTP');
      }
    } catch (error) {
      console.log(error);
      notificationMessage.error('Saving form data failed');
    }
  };

  const saveFormAsComplete = async () => {
    const { data, errors } = validateAndGetFormValues();

    if (errors && errors.length < 1) {
      const hide = message.loading('Saving form, please wait...', 0);

      try {
        await updateFormSubmissions(
          activeSubmissionId,
          JSON.stringify({
            content: JSON.stringify(data),
            status: 'COMPLETE',
          })
        );

        dispatch(setWillTaskListFetch(true));
        setFormDraw(formDraw + 1);

        if (onSuccess !== undefined) {
          onSuccess();
        }

        hide();

        notificationMessage.success('Form successfully submitted');

        setVisible(false);
      } catch (error) {
        hide();
        console.log('error', error);
        let errorMessage =
          error.response?.status === 409
            ? 'Form already submitted'
            : 'Form submission failed';
            notificationMessage.error(errorMessage);
      }
    } else {
      notificationMessage.error('Please fill in the required field(s).');
    }
  };

  const saveAsDraftClick = async () => {
    const {
      actions: { setProp },
      query,
      nodes,
    } = formBuilderUtilities;

    function isNodeOrParentNodeHidden(node) {
      if (node.hidden) return true;
      else if (!node.parent) return false;
      else
        return isNodeOrParentNodeHidden(
          query.getSerializedNodes()[node.parent]
        );
    }

    let data = [];

    Object.keys(nodes).map((serializeNodeKey) => {
      const nodeControl = query.getSerializedNodes()[serializeNodeKey];

      if (!nonValuedControls.includes(nodeControl.displayName)) {
        let nodeValue = '';

        if (nodeControl.props.value && !isNodeOrParentNodeHidden(nodeControl)) {
          nodeValue = nodeControl.props.value;
        }
        // if (typeof nodeControl.props.value !== 'undefined' || nodeControl.props.value !== null) {
        data.push({
          id: serializeNodeKey,
          name: nodeControl.props.name,
          label:
            nodeControl.props.labelText &&
            nodeControl.props.labelText.replace(':', ''),
          value: nodeValue,
          subTitle: nodeControl.props.subTitle
        });
        // }
      }
    });

    const hide = message.loading('Saving form as draft, please wait...', 0);
    hide();

    try {
      await updateFormSubmissions(
        activeSubmissionId,
        JSON.stringify({
          content: JSON.stringify(data),
          status: 'DRAFT',
        })
      );

      hide();

      notificationMessage.success('Form successfully submitted as draft');
    } catch (error) {
      hide();
      console.log('error', error);
      notificationMessage.error('Form submission failed');
    }
  };

  useEffect(() => {
    if (!visible) {
      // Reset Form State
      setOtpValue('');
      setOTPFormShown(false);
      setPageLoading(false);
      setResendOtpOnCooldown(false);
    }
  }, [visible]);

  useEffect(() => {
    if (otpValue.length === 6) {
      validateOTPCode();
    }
  }, [otpValue]);

  useEffect(() => {
    if (!formBuilderUtilities) {
      setFormBuilderUtilities(formBuilderState.utilities);
    }
  }, [formBuilderState.utilities]);

  useEffect(() => {
    if (formBuilderUtilities) {
      const {
        actions: { setProp },
        query,
        nodes,
      } = formBuilderUtilities;

      if (formStatus !== 'COMPLETE') {
        if (formDesignData && formDesignData.prefillEnabled) {
          setFormSubmissionLoading(true);
          (async () => {
            const response = await getMostRecentAnswerPrefill(
              formDesignData.id
            );

            if (response?.data?.data?.content) {
              const formSubmissionContent = JSON.parse(
                response.data.data.content
              );

              Object.keys(nodes).map(async (serializeNodeKey) => {
                const nodeControl =
                  query.getSerializedNodes()[serializeNodeKey];

                if (!nonValuedControls.includes(nodeControl.displayName)) {
                  const formSubmissionItem = formSubmissionContent.find(
                    (jsonFormItem) => jsonFormItem.id === serializeNodeKey
                  );
                  if (!formSubmissionItem){
                    console.log('serializeNodeKey: ' , serializeNodeKey);
                    console.log('formSubmissionContent: ' , formSubmissionContent);
                    return;
                  }  
                  if (nodeControl?.props?.isPrefillable) {
                    await setProp(serializeNodeKey, (props) => {
                      if (!props.value) {
                        props.value = formSubmissionItem.value;
                      }
                    });
                  }
                }
              });
            }

             setFieldsDisabled(false);
            setFormSubmissionLoading(false);
          })();
        }
      } else {
        setFieldsDisabled(true);
      }
    }
  }, [formStatus, formBuilderUtilities, formDesignData]);

  useEffect(() => {
    if (!visible && formBuilderUtilities) {
      clearComponentValues(formBuilderUtilities);
    }
  }, [visible, formBuilderUtilities]);

  const clearComponentValues = (formBuilderUtility) => {
    if (formBuilderUtility) {
      const { actions, query, nodes } = formBuilderUtility;

      if (nodes) {
        Object.keys(nodes).map(async (serializeNodeKey) => {
          const nodeControl = query.getSerializedNodes()[serializeNodeKey];

          if (
            nodeControl &&
            !nonValuedControls.includes(nodeControl.displayName)
          ) {
            if (
              nodeControl.props.hasOwnProperty('value') &&
              nodeControl.props.hasOwnProperty('isVisible')
            ) {
              await actions.setProp(serializeNodeKey, (props) => {
                if (
                  nodeControl.props.displayName === 'Input' &&
                  nodeControl.props.type === 'datetime'
                )
                  //props.value = moment().format('DD/MM/YYYY');
                  props.value = moment();

                if (nodeControl.props.displayName === 'Select')
                  props.value =
                    props.options &&
                    props.options.length > 0 &&
                    props.options[0].value;
                if (
                  nodeControl.props.displayName === 'Input' &&
                  nodeControl.props.type === 'text'
                )
                  props.value = '';

                nodeControl.props.error.required.isVisible = false;
              });
            }
          }
        });

        setFormBuilderUtilities(null);
      }
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={true}
      maxWidth='lg'
      scroll='paper'
      aria-labelledby='responsive-dialog-title'
      open={visible}
      style={{
        overflowX: 'hidden!important',
      }}
      onClose={() => {
        setVisible(false);
      }}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitle
        id='responsive-dialog-title'
        style={{
          borderBottom: '1px solid #ddd',
          background: 'none',
        }}
      >
        {notificationModal && <FileTextOutlined />} {name}
      </DialogTitle>
      <DialogContent
        className='Form-Submission-Body'
        style={{
          minHeight: '50vh',
        }}
      >
        {isPageLoading ? (
          <Row>
            <Col className='text-center'>
              <Spin
                indicator={<LoadingOutlined />}
                style={{ fontSize: 50 }}
                spin
              />
            </Col>
          </Row>
        ) : (
          <>
            <Spin spinning={isFormSubmissionLoading}>
              <div>
                <Editor
                  id={designId}
                  activeSubmissionFormId={activeSubmissionId}
                  setFormDesignData={setFormDesignData}
                  isFieldsDisabled={isFieldsDisabled}
                  span={span}
                />
              </div>
            </Spin>
          </>
        )}
      </DialogContent>
      <DialogActions
        style={{
          borderTop: '1px solid #ddd',
        }}
      >
        {(
          <Container fluid>
            <Row className="justify-content-end">
              <Col
                xs={{
                  order: 1,
                  span: 3,
                }}
                md={{
                  order: 2,
                  span: 3,
                }}
                lg={{
                  order: 2,
                  span: 2,
                }}
                xl={{
                  order: 2,
                  span: 1,
                }}
                className='mt-4 mb-4 p-0'
              >
                <AntdButton  className='p-0 Questionnaire-Button'  onClick={handleModalCancel}>Close</AntdButton>
              </Col>
              {formStatus !== 'COMPLETE' && (span !=='PAST') && (
                <Col
                  xs={{
                    order: 3,
                    span: 3,
                  }}
                  md={{
                    order: 3,
                    span: 3,
                  }}
                  lg={{
                    order: 3,
                    span: 2,
                  }}
                  xl={{
                    order: 3,
                    span: 1,
                  }}
                  className='mt-4 mb-4 p-0'
                >
                  <AntdButton
                    className='Form-Craft-Submit p-0 Questionnaire-Button'
                    type='primary'
                    onClick={saveFormAsComplete}                 
                  >
                    Submit
                  </AntdButton>
                </Col>
              )}
            </Row>
          </Container>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FormSubmitModal;
